<template lang="pug">

    tbody

        //- View
        tr
            td
                strong Agentur
            td {{ viewValue | truncate(16) }}
            td.right.aligned

                a(v-if="$route.name !== 'quality-rating'" v-on:click='showModal()')
                    i.edit.icon

                modal(ref='modal')

                    //- Header
                    span(slot="header") Agentur bearbeiten

                    //- Form
                    form.ui.form(slot="content" v-on:submit.prevent="save()")
                        dropdown-field(
                            label='Agentur'
                            v-bind:options='agencies'
                            v-model='agency'
                        )

                    //- Actions
                    action-row(
                        slot="footer"
                        v-on:cancel="cancel()"
                        v-on:save="save()"
                    )

</template>

<script>
    import { maybe } from 'maybes'
    import ActionRow from '@/components/form/ActionRow.vue'
    import DropdownField from '@/components/form/DropdownField.vue'
    import Modal from '@/components/app/Modal.vue'


    //noinspection ReservedWordAsName,JSUnusedGlobalSymbols
    export default {

        components: { ActionRow, DropdownField, Modal },

        computed: {
            viewValue() {
                return maybe(this.product.agency)
                    .map(agencyId => this.agencies.find(agency => agency.id === agencyId).name)
                    .orJust('-')
            }
        },

        created() {
            this.agency = this.product.agency
        },

        data() {
            return {
                agency: 0,
            }
        },

        methods: {

            cancel() {
                this.$refs.modal.close()
            },

            save() {
                // Payload erstellen
                const model = { ...this.product, agency: this.agency }

                // Speichern
                this.$store.dispatch('products/update', { id: model.id, model }).then(() => {
                    this.$refs.modal.close()
                    this.$growl.success('Agentur wurde gespeichert')
                }).catch(e => {
                    this.$growl.fatal('Agentur konnte nicht gespeichert werden. Bitte an den Support wenden', e)
                })
            },

            showModal() {
                this.$refs.modal.show()
            }
        },

        props: {
            agencies: {
                type: Array,
                required: true
            },
            product: {
                type: Object,
                required: true
            }
        },

        watch: {
            'product.agency'(value) {
                this.agency = value
            }
        }

    }

</script>
